var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelloLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 120,
    viewBox: "10 0 150 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.1857 104.558C50.1314 104.558 48.0728 104.465 46.1115 104.185C38.0761 110.171 30.2266 112.134 30.1294 111.948C32.8389 109.143 34.6142 105.59 35.7344 102.037C21.7178 96.8886 12 85.387 12 72.0115C12 53.7756 30.0364 39 52.1857 39C74.3349 39 92.3713 53.7756 92.3713 72.0115C92.3713 90.2473 74.3349 104.558 52.1857 104.558Z",
    fill: "url(#paint0_linear_79_343)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0361 44.407C23.5702 50.2748 18.9259 58.5065 18.9258 67.7507C18.9258 85.9633 36.9454 100.72 59.0742 100.72C67.1167 100.72 74.6151 98.7687 80.9043 95.4128C73.6613 101.106 63.7629 104.574 52.8662 104.574C50.8139 104.574 48.7573 104.481 46.7979 104.202C38.7698 110.18 30.9272 112.14 30.8301 111.954C33.537 109.153 35.3106 105.604 36.4297 102.055C22.4263 96.9139 12.7178 85.4274 12.7178 72.0691C12.7178 60.4756 20.0206 50.2848 31.0361 44.407Z",
    fill: "url(#paint1_linear_79_343)",
    fillOpacity: 0.11
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5625 100.217C25.5472 95.0898 15.7655 83.6264 15.7655 70.2952C15.7655 59.0173 22.7263 49.1349 33.3548 43.1692C20.6542 48.6711 12 59.578 12 72.1587C12 85.4899 21.7818 96.9533 35.797 102.08C34.6695 105.529 32.9761 109.07 30.1552 111.958C30.2488 112.051 36.2693 107.67 39.5625 100.212V100.217Z",
    fill: "url(#paint2_linear_79_343)",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M138 72.9739C138 55.4423 120.692 41.3164 99.3198 41.3164C77.9475 41.3164 60.6396 55.4423 60.6396 72.9739C60.6396 90.5055 77.9475 104.108 99.3198 104.108C101.155 104.108 102.99 103.978 104.825 103.714C112.823 109.994 120.953 112.084 121.083 111.954C118.198 109.076 116.493 105.281 115.444 101.749C128.817 96.647 137.996 85.7887 137.996 72.9698L138 72.9739Z",
    fill: "url(#paint3_linear_79_343)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M138 72.9739C138 55.4423 120.692 41.3164 99.3198 41.3164C77.9475 41.3164 60.6396 55.4423 60.6396 72.9739C60.6396 90.5055 77.9475 104.108 99.3198 104.108C101.155 104.108 102.99 103.978 104.825 103.714C112.823 109.994 120.953 112.084 121.083 111.954C118.198 109.076 116.493 105.281 115.444 101.749C128.817 96.647 137.996 85.7887 137.996 72.9698L138 72.9739Z",
    fill: "url(#paint4_linear_79_343)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3917 41.3164L96.7721 41.4466C116.224 45.5594 131.18 55.0098 138 73.048C138 55.4754 120.727 41.3164 99.3917 41.3164Z",
    fill: "#FFB116",
    fillOpacity: 0.44
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1362 80.6916H40.363L43.2388 60.1462H48.012L46.8854 68.0916H52.963L54.0896 60.1462H58.8628L55.987 80.6916H51.2139L52.4294 71.8864H46.3814L45.1362 80.6916Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5535 68.7438C74.5535 70.74 73.6147 72.2026 71.737 73.1316C69.8792 74.0605 67.4481 74.6732 64.4439 74.9697C64.5427 76.8276 65.4815 77.7565 67.2603 77.7565C67.9126 77.7565 68.5549 77.6379 69.1874 77.4008C69.8396 77.1636 70.5314 76.7979 71.2627 76.3038L72.9229 79.0906C70.986 80.4939 68.9008 81.1956 66.6674 81.1956C64.434 81.1956 62.7342 80.6026 61.5681 79.4168C60.402 78.2111 59.8189 76.5805 59.8189 74.525C59.8189 72.9438 60.1154 71.3824 60.7083 69.8407C61.321 68.2991 62.2994 67.0144 63.6434 65.9866C64.9874 64.9589 66.6872 64.445 68.7427 64.445C70.5808 64.445 72.0039 64.8502 73.0119 65.6605C74.0396 66.4709 74.5535 67.4986 74.5535 68.7438ZM64.6514 72.1236C66.4895 72.005 67.8236 71.6591 68.6537 71.0859C69.4839 70.493 69.8989 69.7815 69.8989 68.9513C69.8989 68.5758 69.7803 68.2497 69.5432 67.973C69.306 67.6963 68.9206 67.5579 68.3869 67.5579C67.3592 67.5579 66.5389 67.9927 65.9262 68.8624C65.3135 69.732 64.8886 70.8191 64.6514 72.1236Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5482 76.452C80.5087 76.8276 80.5384 77.0944 80.6372 77.2525C80.736 77.4106 80.9139 77.4897 81.1708 77.4897C81.3882 77.4897 81.6452 77.4403 81.9416 77.3415L82.5049 80.6026C81.6155 80.9979 80.6273 81.1956 79.5402 81.1956C78.3741 81.1956 77.4649 80.8991 76.8127 80.3062C76.1802 79.6935 75.864 78.804 75.864 77.6379C75.864 77.3019 75.8936 76.9462 75.9529 76.5706L78.4729 58.6935L83.0979 58.1895L80.5482 76.452Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0891 76.452C89.0496 76.8276 89.0793 77.0944 89.1781 77.2525C89.2769 77.4106 89.4548 77.4897 89.7117 77.4897C89.9291 77.4897 90.1861 77.4403 90.4825 77.3415L91.0458 80.6026C90.1564 80.9979 89.1682 81.1956 88.0811 81.1956C86.915 81.1956 86.0058 80.8991 85.3536 80.3062C84.7211 79.6935 84.4049 78.804 84.4049 77.6379C84.4049 77.3019 84.4345 76.9462 84.4938 76.5706L87.0138 58.6935L91.6388 58.1895L89.0891 76.452Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1752 81.1956C97.0999 81.1956 95.4792 80.6026 94.313 79.4168C93.1667 78.2309 92.5935 76.5904 92.5935 74.4953C92.5935 72.8746 92.8801 71.3033 93.4533 69.7815C94.0265 68.2398 94.9653 66.965 96.2697 65.957C97.594 64.949 99.2937 64.445 101.369 64.445C103.425 64.445 105.035 65.0379 106.202 66.2238C107.368 67.4097 107.951 69.0205 107.951 71.0563C107.951 72.677 107.664 74.2582 107.091 75.7998C106.518 77.3415 105.569 78.6262 104.245 79.6539C102.94 80.6817 101.25 81.1956 99.1752 81.1956ZM99.5013 77.7565C100.865 77.7565 101.824 77.0351 102.377 75.5923C102.93 74.1297 103.217 72.5485 103.237 70.8487C103.237 69.821 103.049 69.0699 102.674 68.5956C102.318 68.1212 101.774 67.884 101.043 67.884C99.6792 67.884 98.7107 68.6153 98.1375 70.0779C97.5841 71.5405 97.3074 73.1118 97.3074 74.7918C97.3074 75.8196 97.4853 76.5706 97.841 77.045C98.1968 77.5193 98.7502 77.7565 99.5013 77.7565Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M110.27 73.1316L111.515 60.1462H116.407L114.005 73.1316H110.27ZM111.248 81.1956C110.556 81.1956 109.993 80.9683 109.558 80.5137C109.123 80.0591 108.906 79.476 108.906 78.7645C108.906 77.9739 109.192 77.292 109.766 76.7189C110.339 76.1259 111.031 75.8295 111.841 75.8295C112.513 75.8295 113.066 76.0567 113.501 76.5113C113.956 76.9659 114.183 77.5391 114.183 78.2309C114.183 79.0412 113.896 79.7429 113.323 80.3358C112.77 80.909 112.078 81.1956 111.248 81.1956Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_79_343",
    x1: 52.1857,
    y1: 39,
    x2: 52.1857,
    y2: 111.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84C73A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1657C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_79_343",
    x1: 21.9288,
    y1: 54.8877,
    x2: 52.8677,
    y2: 111.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#309841"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021C93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_79_343",
    x1: 19.0617,
    y1: 56.0129,
    x2: 35.3247,
    y2: 105.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDDE6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1491CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_79_343",
    x1: 65.7352,
    y1: 70.5002,
    x2: 138.006,
    y2: 76.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F25B02",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305828,
    stopColor: "#F46706"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9717"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_79_343",
    x1: 65.7352,
    y1: 70.5002,
    x2: 138.006,
    y2: 76.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F25B02",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305828,
    stopColor: "#F46706"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9717"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelloLogo);
export default __webpack_public_path__ + "static/media/hello-logo.23775b5eba34e3d7a3cee1e7ba16624d.svg";
export { ForwardRef as ReactComponent };